import { styled } from "styled-components";
import { useRecoilState } from "recoil";
import { recoilStates } from "src/recoil/recoilStates";

export default function WaitEventBookingProposal() {
  const [eventApplication] = useRecoilState(recoilStates.eventApplication);

  // 승인된 클럽 수 계산 (status_id가 3인 경우)
  const approvedClubs =
    eventApplication?.event_booking_rel_club?.filter((clubRel) => clubRel.status_id === 3) || [];

  return (
    <Container>
      <div className="main-content">
        <div className="approval-header">
          <span className="approval-text">승인 골프장 </span>
          <span className="approval-count">{approvedClubs.length}</span>
          <span className="approval-text">개</span>
        </div>

        {eventApplication?.event_booking_rel_club?.map((clubRel, idx) => (
          <div key={`status-card-${clubRel.id}-${idx}`} className="reservation-card status-card">
            <div className="card-header">
              <h3 className="golf-course-name">{clubRel.club?.name}</h3>
              <div className="status-badge reviewing">검토중</div>
            </div>
            <p className="status-message">신청하신 조건을 골프장에서 검토중입니다.</p>
          </div>
        ))}
      </div>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  min-height: 314px;
  background: #fdfdfd;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0 auto;

  /* Main Content */
  .main-content {
    padding: 0 16px 24px;
  }

  .approval-header {
    margin: 4px;
    margin-top: 10px;
  }

  .approval-text {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  .approval-count {
    color: #f97000;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  /* Reservation Cards */
  .reservation-card {
    border: 0.5px solid #d1d5d8;
    border-radius: 6px;
    background: #fdfdfd;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
    margin-bottom: 16px;
  }

  .card-header {
    padding: 11px 16px;
    border-bottom: 0.5px solid #d1d5d8;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .golf-course-name {
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    margin: 0;
  }

  .status-badge {
    padding: 4px 6px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }

  .status-badge.reviewing {
    background: #79818a;
    color: #fdfdfd;
  }

  /* Status Cards */
  .status-card {
    padding-bottom: 16px;
  }

  .status-message {
    color: #79818a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    padding: 0 16px;
    margin: 8px 0 0 0;
  }
`;
